import { NgModule } from "@angular/core";
import { AtlasPipesModule, AtlasSvgIconRegisterModule } from "@asfinag/atlas";
import { AtlasMapModule } from "@asfinag/atlas/map";

@NgModule({
	exports: [AtlasPipesModule, AtlasMapModule, AtlasSvgIconRegisterModule],
})
export class DigitalRoadworkAtlasModule {}
